import { ContactsManager } from '@ts/components/ContactsManager';
import { setVisibilityToggles } from '@ts/utils';

export const init = () => {
    setInteractiveElements();
    document.body.addEventListener('htmx:afterSwap', setInteractiveElements);
    document.body.addEventListener('htmx:historyRestore', setInteractiveElements);
}

const setInteractiveElements = () => {
    ContactsManager.create('.add-contacts-container', {
        cloudSpongeOptions: {
            localeData: {
               PROVIDERS: {
                    csv: 'Team Members'
               },
               POWERED_BY: '',
               IMPORT_CONTACTS: 'Import Your Team Roster',
               SEARCH_CONTACTS: 'Search Team Members',
               SELECT_CONTACTS: 'Select Team Members',
               DRAG_FILES: 'Select and upload an Excel or CSV file containing your Team Members\' info',
               DROP_FILES: 'Click to upload your Excel or CSV file',
               GET_CONTACTS: 'Get ${0} Team Members'
            }
        }
    });
    setVisibilityToggles();
}
